import React, { useEffect, useState } from "react";
import * as yup from "yup";
import { Formik, Form, ErrorMessage } from "formik";
import {
    customStringify,
    error_alert,
    selectStylesField,
    setToken,
    stringNotEmpty,
    success_alert,
} from "../../utils";
import TextField from "../../components/FormikFields/TextField";
import SelectField from "../../components/FormikFields/SelectField";
import DateField from "../../components/FormikFields/DateField";
import { BiLoaderAlt } from "react-icons/bi";
import { Link } from "react-router-dom";
import { login } from "../../redux/slices/userSlice";
import { useDispatch } from "react-redux";
import { email_tl, enter_valid_number, network_tl, required_tl } from "../../translations";
import { FormattedMessage, useIntl } from "react-intl";
import useApi from "../../hooks/useApi";
import { AGENCY_CATEGORIES, BASE_URL, CATEGORIES, EMAIL_REGX, NUMBER_REGEX, ROLE_AGENCY, TELPHONE_MAXIMUM_LENGTH, TELPHONE_MINIMUM_LENGTH } from "../../constants";
import { FaArrowRightLong, FaArrowLeftLong } from "react-icons/fa6";
import { HiOutlinePencil } from "react-icons/hi2";
import { IoIosAddCircle } from "react-icons/io";
import GooglePlacesAutocomplete from 'react-google-places-autocomplete';



const AgencyForm = ({ formData, setFormData, setStep }) => {
    const intl = useIntl();
    const dispatch = useDispatch();
    const { Axios } = useApi();
    const [image, setImage] = useState(formData ? formData.picture : null);

    const initialValues = {
        name: formData ? formData.name : "",
        email: formData ? formData.email : "",
        sur_name: formData ? formData.sur_name : "",
        city: formData ? formData.city : "",
        company_name: formData ? formData.company_name : "",
        type: formData ? formData.type : "",
        contact_number: formData ? formData.contact_number : "",
        tax_code: formData ? formData.tax_code : "",
        role: ROLE_AGENCY.value,
        consent: formData ? formData.consent : false,
        country: formData ? formData.country : "",
        marketing: formData ? formData.marketing : false,
        place_id: formData ? formData.place_id : "",
        address: formData ? formData.address : "",


    };
    yup.addMethod(yup.string, "stringNotEmpty", stringNotEmpty);
    const validationSchema = yup.object({
        name: yup.string().stringNotEmpty(),
        email: yup.string().email(email_tl(intl)).required(required_tl(intl)).matches(EMAIL_REGX, email_tl(intl)),
        sur_name: yup.string().stringNotEmpty(),
        address: yup.string().required(required_tl(intl)),
        // city: yup.string().stringNotEmpty(),
        country: yup.string().required(required_tl(intl)),
        company_name: yup.string().stringNotEmpty(),
        type: yup.object().nullable().required(required_tl(intl)),
        // contact_number: yup.number(enter_valid_number(intl)).typeError(enter_valid_number(intl)).required(required_tl(intl)).integer(enter_valid_number(intl)),
        contact_number: yup.string().matches(NUMBER_REGEX, enter_valid_number(intl)).min(TELPHONE_MINIMUM_LENGTH, enter_valid_number(intl)).max(TELPHONE_MAXIMUM_LENGTH, enter_valid_number(intl)).required(required_tl(intl)),
        tax_code: yup.string().stringNotEmpty(),

        consent: yup.bool().oneOf([true], required_tl(intl)).required(required_tl(intl)),
    });

    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            setImage(URL.createObjectURL(file));
            setFormData((prev) => ({ ...prev, picture: file }));
        }
    };

    const handleSubmit = async (values, formikBag) => {
        setFormData({ ...formData, ...values });
        setStep(2);
    };

    const handleAddressSelect = (place, form) => {

        const terms = place.value.terms;
        const address = place?.label || "";

        console.log(address, "place");
        form.setFieldValue("address", address);

        let city = '';
        let country = '';

        terms.forEach((term, index) => {

            if (index === terms.length - 2) {
                city = term.value;
            }

            if (index === terms.length - 1) {
                country = term.value;
            }
        });

        form.setFieldValue('city', city);
        form.setFieldValue('country', country);
        form.setFieldValue('place_id', place?.value?.place_id);

        console.log('City:', city);
        console.log('Country:', country);
    };

    return (
        <>
            <h1 className='text-3xl font-bold text-t-light'>
                <FormattedMessage id="agency_registration" defaultMessage={"Agency Registration"} />
            </h1>
            <p className='text-start text-sm text-t-light w-[90%]'>
                <FormattedMessage id="influencer_registration_desc" defaultMessage={"Please Enter your details and proceed."} />.
            </p>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {(form) => (
                    <Form className="mt-5">
                        <>
                            <div className="flex justify-center items-center">

                                <div className="relative rounded-full flex items-center justify-center my-5">
                                    <img
                                        src={
                                            image
                                                ? typeof image === "string" 
                                                    ? image
                                                    : URL.createObjectURL(image)
                                                : "/images/avatar.png"
                                        }
                                        alt="Profile"
                                        className="w-20 h-20 rounded-full object-cover border"
                                    />

                                    <label htmlFor="image-upload">
                                        {image ? (
                                            <div

                                                className="absolute -bottom-3 -right-2 rounded-full bg-primary p-2 "
                                            >
                                                <HiOutlinePencil className="text-xl text-white cursor-pointer" />
                                            </div>
                                        ) : (
                                            <IoIosAddCircle className="absolute -bottom-3 -right-2 cursor-pointer text-primary" size={40} />
                                        )}
                                    </label>
                                    <input
                                        id="image-upload"
                                        type="file"
                                        accept="image/*"
                                        onChange={handleImageUpload}
                                        className="hidden"
                                    />
                                </div>
                                </div>
                                <div className="gap-5 grid grid-cols-2 items-center">
                                    <div>
                                        <TextField
                                            type="text"
                                            field="name"
                                            label_text={<FormattedMessage id="name" defaultMessage="Name" />}
                                            form={form}
                                        isRequired

                                        />
                                    </div>
                                    <div>
                                        <TextField
                                            type="text"
                                            field="sur_name"
                                            label_text={<FormattedMessage id="surname" defaultMessage="Surname" />}
                                            form={form}
                                        isRequired

                                        />
                                    </div>

                                    <div className="">
                                        <TextField
                                            type="email"
                                            field="email"
                                            label_text={
                                                <FormattedMessage
                                                    id="email"
                                                    defaultMessage="email"
                                                />
                                            }
                                            form={form}
                                        isRequired

                                        />
                                    </div>
                                    <div>
                                    <label className='text-xs font-medium inline-block'>
                                        <FormattedMessage id="address*" defaultMessage="Address*" />
                                    </label>
                                    <GooglePlacesAutocomplete
                                        apiKey={process.env.REACT_APP_PLACES_API_KEY}
                                        selectProps={{
                                            defaultValue: formData?.address
                                                ? {
                                                    label: formData?.address, // Display address
                                                    value: {
                                                        place_id: formData?.place_id, // Include place_id
                                                    },
                                                }
                                                : null,
                                                
                                            onChange: (place) => handleAddressSelect(place, form),
                                            placeholder: intl.formatMessage({ id: "address", defaultMessage: "Address" }),
                                            styles: selectStylesField(form.touched['address'] && form.errors['address']),
                                            filterOption: (option) => {
                                                console.log('option', option);
                                                // Filter out options where terms.length === 1
                                                return !(option?.data?.value?.terms && option?.data?.value?.terms?.length === 1);
                                            },
                                        }}
                                        
                                    />
                                    {form.errors.address && form.touched.address && (
                                        <p className="text-red-500 text-xs mt-1">{form.errors.address}</p>
                                    )}
                                </div>
                                    <div>
                                        <SelectField
                                            type="text"
                                            options={AGENCY_CATEGORIES}
                                            field="type"
                                            label_text={<FormattedMessage id="type" defaultMessage="Type" />}
                                            form={form}
                                        isRequired

                                        />
                                    </div>
                                    <div>
                                        <TextField
                                            type="text"
                                            field="company_name"
                                            label_text={<FormattedMessage id="company_name" defaultMessage="Company Name" />}
                                            form={form}
                                        isRequired

                                        />
                                    </div>
                                    <div>
                                        <TextField
                                            type="text"
                                            field="contact_number"
                                            label_text={<FormattedMessage id="contact_number" defaultMessage="Contact Number" />}
                                            form={form}
                                        isRequired

                                        />
                                    </div>
                                    {/* <div>
                                        <TextField
                                            type="text"
                                            field="city"
                                            label_text={<FormattedMessage id="city" defaultMessage="City" />}
                                            form={form}
                                        isRequired

                                        />
                                    </div>
                                    <div>
                                        <TextField
                                            type="text"
                                            field="country"
                                            label_text={<FormattedMessage id="country" defaultMessage="Country" />}
                                            form={form}
                                        isRequired

                                        />
                                    </div> */}
                                    
                                    

                                    {/* <div>
                                    <SelectField
                                        type="text"
                                        field="city"
                                        label_text={"City"}
                                        form={form}
                                    />
                                </div> */}
                                    {/* <div>
                                    <SelectField
                                        type="text"
                                        field="country"
                                        label_text={"Country"}
                                        form={form}
                                    />
                                </div> */}


                                    <div>
                                        <TextField
                                            type="text"
                                            field="tax_code"
                                            label_text={<FormattedMessage id="vat_tax_code" defaultMessage="VAT/Tax Code" />}
                                            form={form}
                                            isRequired

                                        />
                                    </div>



                                    {/* <div>
                                    <TextField
                                        type="password"
                                        field="password"
                                        label_text={
                                            <FormattedMessage
                                                id="password"
                                                defaultMessage={"Password"}
                                            />
                                        }
                                        form={form}
                                        password
                                    />
                                </div>
                                <div>
                                    <TextField
                                        type="password"
                                        field="confirm_password"
                                        label_text={"Confirm Password"}
                                        form={form}
                                        password
                                    />
                                </div> */}

                                </div>
                               
                                    
                                        {/* <button
                                        type="button"
                                        disabled={form.isSubmitting}
                                        className="block w-full btn btn-secondary"
                                    >
                                        <p>
                                            {form.isSubmitting ? (
                                                <BiLoaderAlt className="animate-spin text-white text-2xl mx-auto" />
                                            ) : (
                                                <div className="flex space-x-2 justify-center items-center">
                                                    <FaArrowLeftLong className="text-xl  text-primary" />
                                                    <span>Back</span>
                                                </div>
                                            )}
                                        </p>
                                    </button> */}
                                    <div className='mt-8'>
                                <button
                                    className='flex items-start space-x-3' type="button"
                                >
                                    <div className={`flex items-center justify-center space-x-4 `}>
                                        <input
                                            className='transform flex-shrink-0 scale-150  bg-white'
                                            type="checkbox"
                                            onClick={() => {
                                                form.setFieldValue("consent", !form.values.consent)
                                            }}
                                            checked={form.values.consent}
                                        />
                                       <p className='text-xs 2k:text-sm imac:text-base text-secondary font-medium'>
                                            <FormattedMessage
                                                id="policy_consent"
                                                defaultMessage="I have read and agree with {privacyPolicy}*"
                                                values={{
                                                    privacyPolicy: (
                                                        <Link href="/privacy" target="_blank" className="underline">
                                                            <FormattedMessage id="privacy_policy" defaultMessage="privacy policy" />
                                                        </Link>
                                                    ),
                                                }}
                                            />
                                        </p>
                                    </div>
                                </button>
                                {
                                    form.errors['consent'] &&
                                    <p className="-ml-1 mt-1 text-xs text-red-500">
                                        <ErrorMessage name={'consent'} />
                                    </p>
                                }
                            </div>

                            <div className="mt-4 mb-8">
                                <button
                                    className='flex items-start space-x-3'

                                    type="button"
                                >
                                    <div className={`flex items-center justify-center space-x-4 `}>
                                        <input
                                            onClick={() => {
                                                form.setFieldValue("marketing", !form.values.marketing)

                                            }}
                                            className='transform flex-shrink-0 scale-150 rounded-none  bg-white'
                                            type="checkbox"
                                            checked={form.values.marketing}
                                        />
                                        <p className='text-xs 2k:text-sm imac:text-base text-secondary text-start font-medium'>
                                            <FormattedMessage
                                                id="marketing_consent"
                                                defaultMessage="I wish to receive informative or promotional communications about the activities of Influencee, including invitations to events or other initiatives, press releases, and newsletters, also through automated communication systems in accordance with the {privacyPolicy}."
                                                values={{
                                                    privacyPolicy: (
                                                        <Link href="/privacy" target="_blank" className="underline">
                                                            <FormattedMessage id="privacy_policy" defaultMessage="privacy policy" />
                                                        </Link>
                                                    ),
                                                }}
                                            />
                                        </p>
                                    </div>
                                </button>
                                {
                                    form.errors.marketing && form.touched.marketing &&
                                    <p className='text-red-500 text-xs'>
                                        {form.errors.marketing}

                                    </p>
                                }
                            </div>
                                        <button
                                            type="submit"
                                            disabled={form.isSubmitting}
                                            className="block w-full btn btn-primary">
                                            <p>
                                                {form.isSubmitting ? (
                                                    <BiLoaderAlt className="animate-spin text-white text-2xl mx-auto" />
                                                ) : (
                                                    <div className="flex space-x-2 justify-center items-center">
                                                        <span>Proceed</span>
                                                        <FaArrowRightLong className="text-xl mx-auto text-white" />
                                                    </div>
                                                )}
                                            </p>
                                        </button>
                                 
                                
                            
                        </>
                    </Form>
                )}
            </Formik>
        </>
    );
};

export default AgencyForm;
